export interface FacturaListada {
  id: number;

  historica: boolean;
  numero: string | null;
  claveAcceso: string | null;
  clienteId: number;
  cliente: string;
  identificacion: string;
  periodo: string;
  fechaEmision: string;
  vencimiento: string;
  subtotal: number;
  descuento: number;
  total: number;
  estado: string;
  situacionSri: string;

  acreditado: number;

  tieneNotaTotal: boolean;

  fechaAutorizacion?: string | null;

  origen?: string;
}

export const ESTADOS = [
  { valor: 'pendiente', etiqueta: 'Pendientes' },
  { valor: 'pagada', etiqueta: 'Pagadas' },
  { valor: 'exonerada', etiqueta: 'Exoneradas' },
  { valor: 'anulada', etiqueta: 'Anuladas' },
] as const;

export const SITUACIONES = [
  { valor: 'interna', etiqueta: 'Interna' },
  { valor: 'firmada', etiqueta: 'Firmada' },
  { valor: 'enviada', etiqueta: 'Enviada' },
  { valor: 'autorizada', etiqueta: 'Autorizada' },
  { valor: 'rechazada', etiqueta: 'Rechazada' },
  { valor: 'anulada_ante_sri', etiqueta: 'Dada de baja' },
  { valor: 'acreditada', etiqueta: 'Acreditada' },
] as const;

export function colorDelEstado(estado: string): string {
  switch (estado) {
    case 'pagada':
      return 'bg-marca-50 text-marca-700';
    case 'anulada':
      return 'bg-red-50 text-red-700';
    case 'exonerada':
      return 'bg-blue-50 text-blue-700';
    default:
      return 'bg-armazon-100 text-armazon-600';
  }
}

export function colorDeLaSituacion(situacion: string): string {
  switch (situacion) {
    case 'autorizada':
      return 'text-marca-700';
    case 'rechazada':
      return 'text-red-700';
    case 'anulada_ante_sri':
      return 'text-amber-700';
    default:
      return 'text-armazon-400';
  }
}
